import React, { useState, useEffect, useContext, Fragment } from "react";
import { fetchJson } from "../../lib/Fetching";
import Link from "../Link";
import { smallDate as formatDate } from "../../lib/DateFormatting";
import UserContext from "../../lib/UserContext";

export default function QuoteSelector({
  onSelect,
  clientSuiteId,
  clientSpecificationId,
  sampleId,
  matrixId,
  companyId,
}) {
  const [attempts, setAttempts] = useState([]);
  const [selectedAttempt, setSelectedAttempt] = useState(null);
  const [showCustomerActiveQuotes, setShowCustomerActiveQuotes] = useState(false);
  const userContext = useContext(UserContext);

  useEffect(
    () => {
      fetchJson("/quoting/quotables/quotes_for_additional_tests", {
        sample_id: sampleId,
        client_suite_id: clientSuiteId,
        matrix_id: matrixId,
        company_id: companyId,
        show_all_active_quotes: showCustomerActiveQuotes,
      }).then((attempts) => setAttempts(attempts));
    },
    [sampleId || clientSuiteId, showCustomerActiveQuotes]
  );

  useEffect(
    () => {
      onSelect(selectedAttempt ? selectedAttempt.attempt_id : null);
    },
    [selectedAttempt]
  );

  if (attempts.length == 0) return <div>Loading...</div>;

  console.log("CS", clientSpecificationId);

  return (
    <Fragment>
      {!userContext.clientView &&
        sampleId &&
        !clientSpecificationId && (
          <p>
            <label>
              <input
                type="checkbox"
                onChange={() => {
                  setShowCustomerActiveQuotes(!showCustomerActiveQuotes);
                  setSelectedAttempt(null);
                }}
                selected={showCustomerActiveQuotes}
              />
              &nbsp;
              {I18n.t("show_customer_active_quotes")}
            </label>
          </p>
        )}
      <table className="attempts_table table table-condensed" style={{ marginBottom: 0 }}>
        <thead>
          <tr>
            <th>Price List</th>
            <th>Created</th>
            <th>Description</th>
            <th />
          </tr>
        </thead>
        {attempts.map((attempt) => (
          <tr
            key={attempt.attempt_id}
            className={attempt === selectedAttempt ? "selected_attempt" : null}
          >
            <td>
              <Link
                onClick={() => {
                  setSelectedAttempt(attempt);
                  // onSelect(attempt.attempt_id);
                }}
              >
                <div className="attempt_option">Quote {attempt.name}</div>
              </Link>
            </td>
            <td>{formatDate(attempt.created_at)}</td>
            <td>{attempt.description}</td>
          </tr>
        ))}
      </table>
    </Fragment>
  );
}
